export default __webpack_public_path__ + "static/media/hero_candidato.a2fc5ed7.png";